export const sanitizePeople = (people) => {
  const sanitizedPeople = {};
  const validPeopleKeys = [
    'registrant',
    'owner',
    'localContact',
    'propertyManager',
    'tenant',
  ];
  Object.keys(people).forEach((k) => {
    if (validPeopleKeys.includes(k)) {
      if (Array.isArray(people[k])) {
        sanitizedPeople[k] = people[k].map((potentialPerson) =>
          sanitizePersonObject(potentialPerson)
        );
      } else {
        sanitizedPeople[k] = sanitizePersonObject(people[k]);
      }
    }
  });
  return sanitizedPeople;
};

export const sanitizePersonObject = (person) => {
  return {
    firstName: person?.firstName ?? '',
    lastName: person?.lastName ?? '',
    email: person?.email ?? '',
    phone: person?.phone ?? '',
    mailingAddress: person?.mailingAddress ?? '',
    companyName: person?.companyName ?? '',
  };
};
